import type { Crumb } from '@/nav'
import { useBoard } from './api'

export const TAREFAS: Crumb = { label: 'Tarefas', to: '/app/tarefas' }

/** O nome do quadro vem do mesmo cache da tela, então a trilha não busca de novo. */
export function useBoardCrumbs(params: Readonly<Record<string, string>>): readonly Crumb[] {
  const id = params.boardId ?? ''
  const board = useBoard(id)
  return [TAREFAS, { label: board.data?.name ?? 'Quadro' }]
}
